import { atom, selector } from 'recoil';
import { LocationProps } from '../interfaces/Jobs';

export interface FilterItemStateProps {
  name: string;
  id: string;
  selected: boolean;
  category?: {
    id: string;
    name: string;
  };
}

export interface JobFilterStateProps {
  isOpen: boolean;
  job: string;
  location: Partial<LocationProps>;
  distance: string;
  filteredItemsAmount: number;
  occupationTypes: FilterItemStateProps[];
  careerLevels: FilterItemStateProps[];
  benefits: FilterItemStateProps[];
  categories: FilterItemStateProps[];
}

export const JobFilterState = atom<JobFilterStateProps>({
  key: 'jobFilterState',
  default: {
    isOpen: false,
    filteredItemsAmount: 0,
    job: '',
    location: {},
    distance: '',
    occupationTypes: [],
    careerLevels: [],
    benefits: [],
    categories: [],
  },
});

export const filterCountState = selector({
  key: 'filterCount',
  get: ({ get }) => {
    const filters = get(JobFilterState);
    return filters.occupationTypes.filter(({ selected }) => selected).length +
      filters.careerLevels.filter(({ selected }) => selected).length +
      filters.benefits.filter(({ selected }) => selected).length +
      filters.categories.filter(({ selected }) => selected).length;
  },
});